var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-instructions-table',{attrs:{"apply-once-supported":false,"endpoints":_vm.getEndpoints,"instructable-id":_vm.orderId,"instruction-types":['fulfillment', 'admin']}})
}
var staticRenderFns = []

export { render, staticRenderFns }